import React from "react"
import { IPaymentDetail } from "pages/dashboard/wallets/interface"
import { formatCurrencyNoSymbol, isKenyaCurrency } from "utils/currency"
import { getCurrencyDataByCode } from "utils/flags"
import TotalEmployee from "assets/images/total_employee.svg"
import EmployeeLeave from "assets/images/employee_leave.svg"
import { PayoutCard } from "./PayoutCard"

const TopCards: React.FC<{
  /** The unwrapped payload — pass `res?.data`, not the `IBaseRes` envelope. */
  data?: IPaymentDetail
  typeId?: string
  currencyCode?: string
}> = ({ data, typeId, currencyCode }) => {
  const currencySymbol =
    getCurrencyDataByCode(currencyCode ?? "")?.symbol || "₦"

  const amountCard = (
    title: string,
    key: keyof IPaymentDetail,
    icon: string,
  ) => ({
    title,
    value: data?.[key] ? formatCurrencyNoSymbol(Number(data[key])) : 0,
    icon,
  })

  const cards = [
    ...(typeId === "2"
      ? [
          amountCard("Total Tax", "tax_amount", EmployeeLeave),
          amountCard("PAYE", "paye_amount", EmployeeLeave),
          // Kenya is PAYE-only, so there is no withholding tax to show.
          ...(isKenyaCurrency(currencyCode)
            ? []
            : [amountCard("WHT", "wht_amount", TotalEmployee)]),
        ]
      : []),
    ...(typeId === "14"
      ? [amountCard("SSNIT Amount", "ssnit_amount", EmployeeLeave)]
      : []),
    ...(typeId === "15"
      ? [amountCard("NSSF Amount", "nssf_amount", EmployeeLeave)]
      : []),
    ...(typeId === "16"
      ? [amountCard("SHIF Amount", "shif_amount", EmployeeLeave)]
      : []),
    ...(typeId === "17"
      ? [
          amountCard(
            "Housing Levy Amount",
            "housing_levy_amount",
            EmployeeLeave
          ),
        ]
      : []),
    ...(typeId === "3"
      ? [amountCard("Total Pension", "pension_amount", EmployeeLeave)]
      : []),
    ...(typeId === "4"
      ? [amountCard("Total NHF", "nhf_amount", EmployeeLeave)]
      : []),
    ...(typeId === "8"
      ? [amountCard("Total EWA", "ewa_amount", EmployeeLeave)]
      : []),
    ...(typeId === "9"
      ? [amountCard("Total NSITF", "nsitf_amount", EmployeeLeave)]
      : []),
    ...(typeId === "10"
      ? [amountCard("Total ITF", "itf_amount", EmployeeLeave)]
      : []),
  ]

  return (
    <div className=" flex overflow-x-auto scrollbar-hide  mb-4 gap-[11px] justify-start">
      {cards.map((card, index) => (
        <PayoutCard
          key={index}
          title={card.title}
          value={card.value}
          icon={card.icon}
          type={false}
          currency={currencySymbol}
        />
      ))}
    </div>
  )
}

export default TopCards
